'use client';

/**
 * Mounts the global error listeners once, and tells the reporter how to read
 * the CSRF token from the auth store (the reporter itself stays store-free).
 */
import { useEffect } from 'react';
import { installGlobalErrorReporting, setCsrfTokenGetter } from '@/lib/client-errors';
import { useAuthStore } from '@/store/auth-store';

export function ClientErrorReporter() {
  useEffect(() => {
    setCsrfTokenGetter(() => (useAuthStore.getState() as any)?.csrfToken ?? null);
    installGlobalErrorReporting();
  }, []);
  return null;
}

export default ClientErrorReporter;
